import { createAppStore } from '../redux/app-store';
import i18n from 'i18next';

export const formatDate = () => {
  const defaultFormat = 'dd.MM.yyyy';

  const currentLanguage = i18n.language;

  if (currentLanguage === 'nb') {
    return defaultFormat;
  }

  const browserLocale = navigator.language;

  try {
    const sampleDate = new Date(2024, 0, 1); // January 1, 2024
    const formatter = new Intl.DateTimeFormat(browserLocale);

    const parts = formatter.formatToParts(sampleDate);

    const formatMap: { [key: string]: string } = {
      day: 'd',
      month: 'M',
      year: 'y',
      hour: 'H',
      minute: 'm',
      second: 's',
    };

    // Build the format string
    const formatString = parts
      .map((part) => {
        if (part.type in formatMap) {
          return formatMap[part.type].repeat(part.value.length);
        }
        return part.value;
      })
      .join('');

    return formatString;
  } catch (e) {
    return defaultFormat;
  }
};

export const formatTime = () => {
  const state = createAppStore().getState();
  const defaultFormat = 'HH:mm';
  const timeFormat = state.reports.tenantSettings.timeFormat || defaultFormat;
  return timeFormat;
};
